import * as React from "react";

const D = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={1333.333}
    width={1333.333}
    xmlSpace="preserve"
    {...props}
    viewBox="0 0 1333.33 1333.33"
  >
    <path
      style={{
        fill: "#fff",
        fillOpacity: 1,
        fillRule: "nonzero",
        stroke: "none",
      }}
      d="m0 0-62.857-62.857v-874.285L0-1000h750.001l187.142 187.143v625.714L750.001 0Zm311.429-375.714h250v-250h-250z"
      transform="matrix(1.33333 0 0 -1.33333 83.81 0)"
    />
  </svg>
);

export default D;
